module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-stars",
    class: {
      'review-stars--large': _vm.large
    }
  }, _vm._l((_vm.starsToShow), function(star, index) {
    return _c('div', {
      staticClass: "review-star",
      class: {
        'review-star--active': index < _vm.active && _vm.active > 1, 'review-star--low': index < _vm.active && _vm.active == 1
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77cb7fd3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ReviewStars/ReviewStars.vue
// module id = 555
// module chunks = 1